<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div ref="chart" class="wy-panel-map-chart" />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-panel-map-chart',

  methods: {
    async buildChart(mapData) {
      let data = [{
        type: 'choropleth',
        locationmode: 'country names',
        locations: mapData.locations,
        z: mapData.values,
        text: mapData.labels,
        colorscale: [
          [0,'rgb(5, 10, 172)'],[0.35,'rgb(40, 60, 190)'],
          [0.5,'rgb(70, 100, 245)'], [0.6,'rgb(90, 120, 245)'],
          [0.7,'rgb(106, 137, 247)'],[1,'rgb(220, 220, 220)']
        ],
        autocolorscale: false,
        showscale: false,
        reversescale: true,
        marker: {
          line: {
            color: '#4B67A3',
            width: 0.5
          }
        },
        tick0: 0,
        zmin: 0,
        zmax: 17000,
        dtick: 1000,
        colorbar: {
          autotic: false,
          tickprefix: '',
          title: '',
        }
      }];

      var layout = {
        title: '',
        geo:{
          showframe: false,
          showcoastlines: true,
        },
        margin: {
          l: 80,
          r: 80,
          b: 0,
          t: 100,
          pad: 0
        }
      };
      
      let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false, showLink: false};
      // eslint-disable-next-line no-undef
      Plotly.newPlot(this.$refs.chart, data, layout, config);
    }
  },
});
</script>

<style lang="scss">
.wy-panel-map-chart {
  position: relative;
  top: 15px;
  .user-select-none.svg-container{
    bottom: 92px;
  }
  .country-setting-dropdowns{
    margin-right: 15px;
    position: relative;
    left: 871px;
    top: 18px;
  }
}
</style>